// extracted by mini-css-extract-plugin
export default {"signatureField":"vB0s8H","header":"jYOxCl","inputContainer":"_1PlHdo"};